/**
 * Aplica la máscara de número telefónico de Guatemala: 8 dígitos
 * agrupados como `NNNN-NNNN`. Descarta cualquier carácter no numérico
 * y trunca a 8 dígitos. Pensada para usarse en `onChange` del input para
 * que el usuario vea el formato mientras escribe.
 *
 * Casos:
 *  - `''`          → `''`
 *  - `'1'`         → `'1'`
 *  - `'1234'`      → `'1234'`
 *  - `'12345'`     → `'1234-5'`
 *  - `'12345678'`  → `'1234-5678'`
 *  - `'12345678 9'`→ `'1234-5678'` (trunca a 8 dígitos)
 *  - `'+502 5555 1234'` → `'5025-5551'` (descarta no-dígitos, trunca)
 */
export function formatPhoneGT(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 4) return digits;
  return `${digits.slice(0, 4)}-${digits.slice(4)}`;
}
